import React from 'react'
import StateSelectorFormsy from './StateSelectorFormsy'
import clsx from 'clsx'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export default function StyledStateSelectorFormsy(props) {
  const { className, ...rest } = props
  return (
    <StateSelectorFormsy
      {...rest}
      className={clsx(className, 'w-full')}
      variant="outlined"
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'center',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        getContentAnchorEl: null,
        PaperProps: {
          style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
          },
        },
      }}
    />
  )
}
